<template>
  <div
    v-if="loading === false"
    class="payment-methods"
  >
    <slot />
    <span
      v-for="payment in payments"
      :key="payment.name"
      class="payment-method"
      v-html="payment.icon"
    />
  </div>
</template>

<script>
import api from '../api.js'
import eventBus from '../eventBus.js'

export default {
  name: 'CPaymentMethods',

  data () {
    return {
      loading: true,
      payments: []
    }
  },

  created () {
    if (this.$store.state.payments.length === 0) {
      api.get('checkout/payments/').then(response => {
        this.$store.state.payments = response.data
        this.payments = response.data
        this.loading = false
      }, error => {
        this.loading = false
        eventBus.emit('handleError', error.response.data.error)
      })
    } else {
      this.payments = this.$store.state.payments
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.payment-method svg {
  height: 3em;

  &:first-child {
    margin-right: ($gutter-sm * 0.5);
  }

  &:last-child {
    margin-left: ($gutter-sm * 0.5);
  }
}

.payment-methods {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: $gutter-sm;

  @media (min-width: $breakpoint-md) {
    margin-bottom: ($gutter-md - $gutter-sm * 0.5);
  }
}
</style>
